/* InputTime.tsx
   Version: 1.0.0
   Date: 2020-12-10
*/

// eslint-disable-next-line
import * as React from 'react';
import PropTypes from 'prop-types';

export interface InputTimeProps {
    className?: string
    name: string;
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const InputTime: React.FC<InputTimeProps> = (props): JSX.Element => {

    InputTime.propTypes = {
        className: PropTypes.string,
        name: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired
    }


    return <input className={props.className ?? 'basic-inputtext'} type='time' data-name={props.name} value={props.value} onChange={props.onChange} />

}

export default InputTime;
